export default __webpack_public_path__ + "static/media/save-time.4e6b0594.svg";